import { MentionMeConfig } from '../../models/mention-me/mention-me-config.interface';
import { mockMentionMeDomainConfig } from './mention-me-domain-config.mock';

export const mockMentionMeConfig: MentionMeConfig = {
  ...mockMentionMeDomainConfig,
  mentionMeApi: 'https://mock.api.com',
};
